"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertainItemsType = exports.Status = exports.DateType = void 0;
/**
 * 查询日期类型
 */
var DateType;
(function (DateType) {
    DateType["After"] = "AFTER";
    DateType["Before"] = "BEFORE";
    DateType["Customize"] = "CUSTOMIZE";
    DateType["LastMonth"] = "LAST_MONTH";
    DateType["LastWeek"] = "LAST_WEEK";
    DateType["PastHalfMonth"] = "PAST_HALF_MONTH";
    DateType["PastHalfYear"] = "PAST_HALF_YEAR";
    DateType["PastMonth"] = "PAST_MONTH";
    DateType["PastQuarter"] = "PAST_QUARTER";
    DateType["PastThreeDays"] = "PAST_THREE_DAYS";
    DateType["PastWeek"] = "PAST_WEEK";
    DateType["PastYear"] = "PAST_YEAR";
    DateType["ThisMonth"] = "THIS_MONTH";
    DateType["ThisQuarter"] = "THIS_QUARTER";
    DateType["ThisWeek"] = "THIS_WEEK";
    DateType["ThisYear"] = "THIS_YEAR";
    DateType["Today"] = "TODAY";
    DateType["Yesterday"] = "YESTERDAY";
})(DateType || (exports.DateType = DateType = {}));
/**
 * 状态
 */
var Status;
(function (Status) {
    Status["Ended"] = "ENDED";
    Status["InProgress"] = "IN_PROGRESS";
    Status["NotStarted"] = "NOT_STARTED";
})(Status || (exports.Status = Status = {}));
/**
 * 可订货日期枚举
 */
var CertainItemsType;
(function (CertainItemsType) {
    CertainItemsType["NO_LIMIT"] = "NO_LIMIT";
    CertainItemsType["FIXD_DAY"] = "FIXD_DAY";
    CertainItemsType["FIXED_WEEK"] = "FIXED_WEEK";
})(CertainItemsType || (exports.CertainItemsType = CertainItemsType = {}));
